import { client, BASE_URL } from "./client.ts";

const base_url = "/insp-model";
const defaultModelInfo = {
  name: "",
  trainModel_id: "",
  options: "{}",
  pre_process: "{}",
  post_process: "{}",
  description: "",
};

const defaultBaseModelInfo = {
  name: "",
  description: "",
  options: "{}",
  pre_process: "{}",
  post_process: "{}",
};

// 모델 전체 조회
export const getModels = async (params) => {
  try {
    const response = await client.get(base_url, { params });
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// 모델 단일 조회
export const getModelDetail = async (id) => {
  try {
    const response = await client.get(`${base_url}/${id}`);
    return response.data;
  } catch (error) {
    console.error(error);
    return [];
  }
};

// 모델 추가
export const addModel = async (modelInfo) => {
  try {
    const response = await client.post(base_url, {
      ...defaultModelInfo,
      ...modelInfo,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// 모델 수정
export const editModel = async (id, modelInfo) => {
  try {
    const response = await client.patch(`${base_url}/${id}`, {
      ...modelInfo,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// 모델 삭제
export const deleteModel = async (id) => {
  try {
    const response = await client.delete(`${base_url}/${id}`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

// 학습모델 리스트 전체 조회
export const getTrainModels = async (params) => {
  try {
    const response = await client.get(`/model/trainmodel`, { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// 검사모델 조회
export const getInspModels = async (params) => {
  try {
    const response = await client.get(`${base_url}`, { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// 검사모델 조회
// param : id or uuid
export const getInspModel = async (id) => {
  try {
    const response = await client.get(`${base_url}/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

const createInspModel = async () => {
  try {
    const response = await client.post(`${base_url}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
